import React from 'react'
import Answer from './message/Answer'
import Question from './message/Question'
import Typing from './message/Typing'
import Redirect from './message/Redirect'
import Info from './message/Info'
import { Message, MessageType } from '~/service/chatConn/types'
import HorizontalLine from './message/HorizontalLine'

export type MessageSwitchProps<T extends Message> = {
  message: T
  style: object
  animationClassName: string
  animationPayload: any
  isLast: boolean
  parentWidth: number
}

const messageComponentMap: {
  [key in MessageType]?: React.ComponentType<MessageSwitchProps<any>>
} = {
  ['TYPING']: Typing,
  ['REDIRECT']: Redirect,
  ['USER']: Answer,
  ['AI']: Answer,
  ['INFO']: Info,
  ['CLIENT']: Question,
  ['UNREAD']: HorizontalLine,
  ['LIVECHAT_START']: HorizontalLine,
  ['LIVECHAT_END']: HorizontalLine,
}

const MessageSwitch: React.FC<MessageSwitchProps<Message>> = props => {
  const { message } = props
  const Component = messageComponentMap[message.type]
  if (!Component) {
    return null
  }
  return <Component {...props} />
}

export default MessageSwitch
